var map = {
	"./en-US/apimanagement.json": [
		68850,
		"libs_i18n-resources_en-US_apimanagement_json"
	],
	"./en-US/app.json": [
		79246,
		"libs_i18n-resources_en-US_app_json"
	],
	"./en-US/auth.json": [
		93957,
		"libs_i18n-resources_en-US_auth_json"
	],
	"./en-US/balancemanagement.json": [
		87074,
		"libs_i18n-resources_en-US_balancemanagement_json"
	],
	"./en-US/common.json": [
		48818,
		"libs_i18n-resources_en-US_common_json"
	],
	"./en-US/dashboards.json": [
		12154,
		"libs_i18n-resources_en-US_dashboards_json"
	],
	"./en-US/disputes.json": [
		23758,
		"libs_i18n-resources_en-US_disputes_json"
	],
	"./en-US/notifications.json": [
		82821,
		"libs_i18n-resources_en-US_notifications_json"
	],
	"./en-US/orders.json": [
		87506,
		"libs_i18n-resources_en-US_orders_json"
	],
	"./en-US/payment.json": [
		60555,
		"libs_i18n-resources_en-US_payment_json"
	],
	"./en-US/platformsettings.json": [
		65281,
		"libs_i18n-resources_en-US_platformsettings_json"
	],
	"./en-US/team.json": [
		53178,
		"libs_i18n-resources_en-US_team_json"
	],
	"./en-US/transactions.json": [
		46178,
		"libs_i18n-resources_en-US_transactions_json"
	],
	"./en-US/users.json": [
		95273,
		"libs_i18n-resources_en-US_users_json"
	],
	"./en-US/widgets.json": [
		12540,
		"libs_i18n-resources_en-US_widgets_json"
	],
	"./ru-RU/apimanagement.json": [
		72309,
		"libs_i18n-resources_ru-RU_apimanagement_json"
	],
	"./ru-RU/app.json": [
		63441,
		"libs_i18n-resources_ru-RU_app_json"
	],
	"./ru-RU/auth.json": [
		32420,
		"libs_i18n-resources_ru-RU_auth_json"
	],
	"./ru-RU/balancemanagement.json": [
		35541,
		"libs_i18n-resources_ru-RU_balancemanagement_json"
	],
	"./ru-RU/common.json": [
		47671,
		"libs_i18n-resources_ru-RU_common_json"
	],
	"./ru-RU/dashboards.json": [
		32239,
		"libs_i18n-resources_ru-RU_dashboards_json"
	],
	"./ru-RU/disputes.json": [
		81167,
		"libs_i18n-resources_ru-RU_disputes_json"
	],
	"./ru-RU/notifications.json": [
		1854,
		"libs_i18n-resources_ru-RU_notifications_json"
	],
	"./ru-RU/orders.json": [
		83879,
		"libs_i18n-resources_ru-RU_orders_json"
	],
	"./ru-RU/payment.json": [
		35428,
		"libs_i18n-resources_ru-RU_payment_json"
	],
	"./ru-RU/platformsettings.json": [
		1400,
		"libs_i18n-resources_ru-RU_platformsettings_json"
	],
	"./ru-RU/team.json": [
		62383,
		"libs_i18n-resources_ru-RU_team_json"
	],
	"./ru-RU/transactions.json": [
		98523,
		"libs_i18n-resources_ru-RU_transactions_json"
	],
	"./ru-RU/users.json": [
		97154,
		"libs_i18n-resources_ru-RU_users_json"
	],
	"./ru-RU/widgets.json": [
		12235,
		"libs_i18n-resources_ru-RU_widgets_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9266;
module.exports = webpackAsyncContext;